var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  d: "M8.33 3.334h3.334a6.665 6.665 0 0 1 6.667 6.667 6.665 6.665 0 0 1-6.667 6.666H8.331a6.665 6.665 0 0 1-6.667-6.666 6.665 6.665 0 0 1 6.667-6.667Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  d: "M8.333 13.333a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Z"
})));
export { SvgDisable as ReactComponent };
export default __webpack_public_path__ + "6de2a8b49ae7e5e07c71b47479b81f28.svg";